import React, { useState } from 'react';
import useGetVehicle from '../hooks/useGetVehicle';
import useGetSellers from '../hooks/useGetSellers';
import useConfig from '../hooks/useConfig';

const VehicleSeller = () => {
  const { copies, hideSellerInfo } = useConfig();
  const {
    vehicle: { seller },
  } = useGetVehicle();
  const { sellers } = useGetSellers();

  if (!sellers || sellers.length === 1) return null;

  return (
    <div className="flex items-center">
      {!hideSellerInfo && (
        <div>
          {Boolean(seller.logo) && (
            <img
              variant="square"
              alt={seller.name}
              src={seller.logo}
              className="w-14 h-14 mr-3 object-contain"
            />
          )}
          <div>
            <p>
              {`${copies.soldBy} `}
              <b>{seller.name}</b>
            </p>
            <p className="text-sm text-gray-500">{seller.address}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default VehicleSeller;
